import { getDocs, collection, query, where } from "@firebase/firestore";
import { hideLoading, setForSaleWigsList, showLoading } from "./for-sale-wigs-list-slice";

export const getForSaleWigsService = async (dispatch, db, coll) => {
    try {
        dispatch(showLoading());
        const querySnapshot = await getDocs(
            query(collection(db, coll), where("type", "==", "For sale"), where("category", "==", "Wig"))
        );
        const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        dispatch(setForSaleWigsList(data));
        dispatch(hideLoading());
    } catch (e) {
        console.error("ForSaleWigsList getForSaleWigsService error: ", e);
    }
};